'use client'

import { useState, useEffect } from 'react'

export function usePlatformLink() {
  const [platformLink, setPlatformLink] = useState('/login?mode=signup')
  const [platform, setPlatform] = useState('web')

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    const isMobileDevice = /android|iPad|iPhone|iPod/i.test(userAgent)

    if (!isMobileDevice) {
      setPlatform('web')
      setPlatformLink('/login?mode=signup')
      return
    }

    // Detect iOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setPlatform('ios')
      setPlatformLink('https://apple.co/3Cmgy10')
    } else {
      setPlatform('android')
      setPlatformLink('https://play.google.com/store/apps/details?id=com.jegan.aiva&pcampaignid=web_share')
    }
  }, [])

  return { platformLink, platform, isMobile: platform !== 'web' }
}
